import React from 'react';
import AnalizeClienti from './Analize';
import { List, ListItem, ListItemText, Grid } from '@material-ui/core';
import SpecificComponent from '../../commons/SpecificComponent';


export default class ClientiNoiLunar extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            listClientiNoi: { lunaCurenta: [], lunaAnterioara: [], acum2Luni: [] },
            listClientiNew: [],
            year: new Date().getFullYear(),
            months: []
        }
    }

    componentDidMount() {
       // this.nAnalize()
        this.getMonthsOfYear(this.state.year)
    }

    nAnalize = async () => {
        console.clear()
        let a = new AnalizeClienti()




        // let cC = await a.getClientiCastigatiLunar()  // acopera si clienti noi
        // console.warn('clienti castigatiLUnar = ', cC)



        let clientiNoi2 = await a.getClientiLunar2(2019, 4)

        // console.warn('clientiNoi2 :', clientiNoi2);


        // let cSS = await a.analizaPeSemestru()
        // console.log('analiza semestriala = ', cSS)


        this.setState({ listClientiNew: clientiNoi2 })

    }

    getMonthsOfYear =async (year) => {
        let a = new AnalizeClienti()

        let months = [{ luna: 'Ianuarie', data: [] },
        { luna: 'Februarie', data: [] },
        { luna: 'Martie', data: [] },
        { luna: 'Aprilie', data: [] },
        { luna: 'Mai', data: [] },
        { luna: 'Iunie', data: [] },
        { luna: 'Iulie', data: [] },
        { luna: 'August', data: [] },
        { luna: 'Septembrie', data: [] },
        { luna: 'Octombrie', data: [] },
        { luna: 'Noiembrie', data: [] },
        { luna: 'Decembrie', data: [] }

        ]

        let counter = months.length
        let clientiNoi2 = await a.getClientiLunar2()
        // console.log('clientiNoi2 :', clientiNoi2);

        for (let i = 0; i < counter; i++) {
            for(let k = 0 , n= clientiNoi2.length; k< n; k++){
          
                    if(clientiNoi2[k].data[clientiNoi2[k].data.length - 1].an === year && clientiNoi2[k].data[clientiNoi2[k].data.length - 1].luna === i+1){
                    
                        months[i].data.push(clientiNoi2[k])
                    }
                }
            
        }

        // console.log('months :', months);

        this.setState({ months: months })
    }

    changeDate=(nr)=>{

        let yearToChange = this.state.year

        let newYear = yearToChange + (nr)

        this.setState({
            year:newYear
        },()=>{
            this.getMonthsOfYear(newYear)
        })


        
    }


    render() {
        return (
            <div>
                {this.state.listClientiNoi &&
                    <div >
                     
                        <h2 className='pm-title'><i onClick={()=>{this.changeDate(-1)}} className='material-icons' style={{fontSize:35, 
                                                                                                                        cursor:'pointer',
                                                                                                                        color:'#228bda'}}>keyboard_arrow_left</i>
                                                <span style={{verticalAlign:'super' }}>{this.state.year}</span>
                                                <i onClick={()=>{this.changeDate(1)}} style={{fontSize:35, 
                                                                                                cursor:'pointer',
                                                                                                color:'#228bda'}} className='material-icons'>keyboard_arrow_right</i> </h2>
                        <Grid container>

                            {this.state.months.map((m, idx) => {
                                return (


                                    <Grid key={idx} style={{ width: 'fit-content', marginTop: 10,borderLeft:idx > 0 ? '1px solid gray' : '' }} item xs={3} sm={3} md={1} lg={1} xl={1} >
                                        <h4 className='pm-title' style={{borderBottom:'1px solid gray'}}>{m.luna}</h4>
                                        <List >
                                            {m.data.map((l, idx) => {
                                                return (



                                                    <ListItem key={idx} style={{ textAlign: 'center', justifyContent: 'center' }}>
                                                        <span className='pm-title' style={{ fontSize: 12  }}>{l.client}</span>
                                                    </ListItem>
                                                )
                                            })}
                                        </List>
                                    </Grid>

                                )

                            })}


                        </Grid>
                        {/* <List>
                            {this.state.listClientiNew.map((l, idx) => {
                                return (



                                    <ListItem key={idx} style={{ textAlign: 'center', justifyContent: 'center' }}>
                                        <span className='pm-title' style={{ fontSize: 14 }}>{l.client}</span>
                                    </ListItem>
                                )
                            })}
                        </List> */}

                        {this.state.listClientiNoi.lunaCurenta.length > 0 &&
                            <div className='container'>
                                <h2 className='pm-title'>{this.dictionary.financiarContabil.lunaCurenta}</h2>
                                <List>
                                    {this.state.listClientiNoi.lunaCurenta.map((l, idx) => {
                                        return (



                                            <ListItem key={idx} style={{ textAlign: 'center', justifyContent: 'center' }}>
                                                <span className='pm-title'>{l.client}</span>
                                            </ListItem>
                                        )
                                    })}
                                </List>
                            </div>


                        }

                        {this.state.listClientiNoi.lunaAnterioara.length > 0 &&
                            <div>
                                <h2 className='pm-title'>{this.dictionary.financiarContabil.lunaAnterioara}</h2>
                                <List>
                                    {this.state.listClientiNoi.lunaAnterioara.map((l, idx) => {
                                        return (



                                            <ListItem key={idx} style={{ textAlign: 'center', justifyContent: 'center' }}>
                                                <span className='pm-title'>{l.client}</span>
                                            </ListItem>
                                        )
                                    })}
                                </List>
                            </div>


                        }

                        {this.state.listClientiNoi.acum2Luni.length > 0 &&
                            <div>
                                {/* <h2 className='pm-title'>{this.dictionary.financiarContabil.acum2Luni}</h2> */}
                                <List>
                                    {this.state.listClientiNoi.acum2Luni.map((l, idx) => {
                                        return (



                                            <ListItem key={idx} style={{ textAlign: 'center', justifyContent: 'center' }}>
                                                <span className='pm-title'>{l.client}</span>
                                            </ListItem>
                                        )
                                    })}
                                </List>
                            </div>


                        }
                    </div>





                }
            </div>
        );
    }
}